import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-receipt-confirmation-details',
    templateUrl: './receipt-confirmation-details.component.html',
    styleUrls: ['./receipt-confirmation-details.component.scss'],
    standalone: false
})
export class ReceiptConfirmationDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
